import { createContext } from "react";

export const InvestAccountContext = createContext();

